module.exports = __webpack_public_path__ + "img/Bodice-Front-B3-Da-Eb.ea38f29d.png";